import { useEffect, useState } from "react";
import FalconReactRange from "./doc-components/FalconReactRange";




const RangeSlider = ({ values, setValues,min,max,step,disabled }) => {
  const labels = ["low", "normal", "high"]; // Labels for the slider positions
  
  const [variant,setVariant]=useState('gray');

  const setValueHandler = (val) => {
      console.log('hello', val);
      setValues(val);   
  };

  function checkValue(value, minValue, maxValue) {
    const range = maxValue - minValue;
    const halfValue = minValue + range / 2;

    if (value === minValue) {
        return 'minimum';
    } else if (value === halfValue) {
        return 'half';
    } else if (value === maxValue) {
        return 'maximum';
    } else {
        return 'none';
    }
}


  useEffect(()=>{
    if (checkValue(values[0], min, max) === 'minimum') {
      setVariant('green');
    } else if (checkValue(values[0], min, max) === 'half') {
      setVariant('yellow');
    } else if (checkValue(values[0], min, max) === 'maximum') {
      setVariant('red');
    }
  },[values])

  return (
      <>
  <div style={{ display: 'flex'}}>
   <div style={{width:'95%'}}>
          <FalconReactRange
              values={values}
              variant={variant}
              step={step}
              min = {min}
              max = {max}
              onChange={(val) => setValueHandler(val)}
              disabled={disabled}
          />
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '-5px' }}>
          <span  style={{ color:'green',fontSize:'14px',fontWeight:'bold' }}>  Low   </span>
          <span  style={{ color:'orange',fontSize:'14px',fontWeight:'bold' }}>  Normal   </span>
          <span  style={{ color:'red',fontSize:'14px',fontWeight:'bold' }}> High   </span>
          </div>

          </div>


          <div style={{ color: 'black', fontSize: '14px', fontWeight: 'bold',marginTop:'7px',marginLeft:'10px' }}>
          {/* Display the selected value on the right side */}
        {values}
        </div>
        </div>
      </>
  );
};

export default RangeSlider;
